import React, { useState, useEffect } from 'react'
import { DaysOfTheWeekDiv, DayOfTheWeek } from '../../../../../components/AddCompanyModal/DisponibilityComponent/style'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  ContentContainer,
  Section,
  SectionHeader,
  FormGrid,
  StyledFormGroup,
  MaintenanceServiceWrapper,
  NameGroup,
  PeriodicidadeGroup,
  DeleteButton,
  AddMaintenanceButton,
  CancelButton,
  SaveButton,
  ButtonContainer
} from '../RegisterVehicleModal/style'
import { BlurBackground } from '../../style'
import crosslight from '../../../../../assets/stock/FiltersHeader/cross.svg'
import plus from '../../../../../assets/certificates/AddParameter/blue-plus.svg'
import save from '../../../../../assets/certificates/AddParameter/save.svg'
import trash from '../../../../../assets/equipment/Tables/trash.svg'

export interface ExistingVehicleData {
  id: string
  plate: string
  model: string
  year: number
  capacity: string
  bodyType: string
  restriction: string | null
  periodicMaintenances: Array<{
    maintenanceName: string
    periodicityValue: number
    periodicityUnit: string
  }>
}

interface EditVehicleModalProps {
  isOpen: boolean
  onClose: () => void
  initialVehicleData: ExistingVehicleData | null
  onSave: (vehicleId: string, vehicleData: any) => Promise<boolean>
  vehicleId: string
}

interface PeriodicMaintenanceData {
  localId: number 
  maintenanceName: string
  periodicityValue: number | ''
  periodicityUnit: string
}

const EditVehicleModal: React.FC<EditVehicleModalProps> = ({
  isOpen,
  onClose,
  initialVehicleData,
  onSave,
  vehicleId,
}) => {
  const [plate, setplate] = useState<string>('')
  const [model, setModel] = useState<string>('')
  const [year, setYear] = useState<number | ''>('')
  const [capacity, setcapacity] = useState<string>('')
  const [bodyType, setBodyType] = useState<string>('')
  const [restriction, setRestriction] = useState<string>('')
  const [isSaving, setIsSaving] = useState<boolean>(false)

  const [periodicMaintenances, setPeriodicMaintenances] = useState<
    PeriodicMaintenanceData[]
  >([])

  useEffect(() => {
    if (isOpen && initialVehicleData) {
      setplate(initialVehicleData.plate)
      setModel(initialVehicleData.model)
      setYear(initialVehicleData.year)
      setcapacity(initialVehicleData.capacity)
      setBodyType(initialVehicleData.bodyType)
      setRestriction(initialVehicleData.restriction || '')

      setPeriodicMaintenances(
        initialVehicleData.periodicMaintenances.map((pm) => ({
          localId: Date.now() + Math.random(), 
          maintenanceName: pm.maintenanceName,
          periodicityValue: pm.periodicityValue,
          periodicityUnit: pm.periodicityUnit,
        })),
      )
    } else if (!isOpen) {

      setplate('')
      setModel('')
      setYear('')
      setcapacity('')
      setBodyType('')
      setRestriction('')
      setPeriodicMaintenances([])
      setIsSaving(false)
    }
  }, [isOpen, initialVehicleData])

  if (!isOpen) {
    return null
  }

  const handleAddMaintenance = () => {
    setPeriodicMaintenances([
      ...periodicMaintenances,
      {
        localId: Date.now() + Math.random(),
        maintenanceName: '',
        periodicityValue: '',
        periodicityUnit: '',
      },
    ])
  }

  const handleDeleteMaintenance = (localId: number) => {
    setPeriodicMaintenances(
      periodicMaintenances.filter((pm) => pm.localId !== localId),
    )
  }

  const handleMaintenanceChange = (
    localId: number,
    field: keyof PeriodicMaintenanceData,
    value: string | number,
  ) => {
    setPeriodicMaintenances(
      periodicMaintenances.map((pm) =>
        pm.localId === localId ? { ...pm, [field]: value } : pm,
      ),
    )
  }

  const handleSaveClick = async () => {
    if (isSaving || !vehicleId) return

    if (!plate || !model || !year) {

      console.error('Por favor, preencha a Placa, Modelo e Ano.')
      
      return
    }

    setIsSaving(true)

    const vehicleDataToSend = {
      plate,
      model,
      year: Number(year),
      capacity,
      bodyType,
      restriction: restriction || null,
      periodicMaintenances: periodicMaintenances
        .filter(
          (pm) =>
            pm.maintenanceName || pm.periodicityValue || pm.periodicityUnit,
        ) 
        .map(({ localId, ...rest }) => rest), 
    }

    const success = await onSave(vehicleId, vehicleDataToSend)

    setIsSaving(false)

    if (success) {
      onClose() 
    }
  }

  return (
    <BlurBackground>
      <Container>
        <HeaderDiv>
          <HeaderText>Editar veículo</HeaderText>
          <CloseDiv onClick={onClose}>
            <img
              src={crosslight}
              alt='Close'
              style={{ width: '12px', height: '12px' }}
            />
          </CloseDiv>
        </HeaderDiv>

        <ContentContainer>
          <Section>
            <FormGrid cols={2}>
              <StyledFormGroup>
                <label htmlFor='placa'>Placa</label>
                <input
                  type='text'
                  id='placa'
                  placeholder='Digite aqui'
                  value={plate}
                  onChange={(e) => setplate(e.target.value)}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='modelo'>Modelo</label>
                <input
                  type='text'
                  id='modelo'
                  placeholder='Digite aqui'
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='ano'>Ano</label>
                <input
                  type='number'
                  id='ano'
                  placeholder='Digite aqui'
                  value={year}
                  onChange={(e) => setYear(parseInt(e.target.value) || '')}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='capacidadeCarga'>Capacidade de carga</label>
                <input
                  type='text'
                  id='capacidadeCarga'
                  placeholder='Digite aqui'
                  value={capacity}
                  onChange={(e) => setcapacity(e.target.value)}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='tamanhoCarroceria'>Tamanho da carroceria</label>
                <input
                  type='text'
                  id='tamanhoCarroceria'
                  placeholder='Digite aqui'
                  value={bodyType}
                  onChange={(e) => setBodyType(e.target.value)}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label>Restrição de rodagem</label>
                <DaysOfTheWeekDiv style={{ marginTop: '0.4rem' }}>
                  {['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira'].map((day, idx) => (
                    <DayOfTheWeek
                      key={day}
                      onClick={() => setRestriction(restriction === day ? '' : day)}
                      className={restriction === day ? 'actived' : ''}
                      title={day}
                    >
                      {['S', 'T', 'Q', 'Q', 'S'][idx]}
                    </DayOfTheWeek>
                  ))}
                </DaysOfTheWeekDiv>
              </StyledFormGroup>
            </FormGrid>
          </Section>

          <Section>
            <SectionHeader>Manutenção periódica</SectionHeader>
            {periodicMaintenances.map((pm, index) => (
              <MaintenanceServiceWrapper key={pm.localId}>
                <NameGroup>
                  <label htmlFor={`manutencaoNome-${pm.localId}`}>Nome</label>
                  <input
                    type='text'
                    id={`manutencaoNome-${pm.localId}`}
                    placeholder='Digite aqui'
                    value={pm.maintenanceName}
                    onChange={(e) =>
                      handleMaintenanceChange(
                        pm.localId,
                        'maintenanceName',
                        e.target.value,
                      )
                    }
                  />
                </NameGroup>
                <PeriodicidadeGroup>
                  <label>Periodicidade</label>
                  <div className='input-wrapper'>
                    <span className='prefix-text'>A cada</span>
                    <input
                      type='number'
                      placeholder='Digite aqui'
                      value={pm.periodicityValue}
                      onChange={(e) =>
                        handleMaintenanceChange(
                          pm.localId,
                          'periodicityValue',
                          parseInt(e.target.value) || '',
                        )
                      }
                    />
                    <select
                      value={pm.periodicityUnit}
                      onChange={(e) =>
                        handleMaintenanceChange(
                          pm.localId,
                          'periodicityUnit',
                          e.target.value,
                        )
                      }
                    >
                      <option value=''>Selecione</option>
                      <option value='m'>Metros</option>
                      <option value='km'>Quilômetros</option>
                    </select>
                  </div>
                </PeriodicidadeGroup>
                <DeleteButton onClick={() => handleDeleteMaintenance(pm.localId)}>
                  <img src={trash} alt='Excluir' />
                </DeleteButton>
              </MaintenanceServiceWrapper>
            ))}
            <AddMaintenanceButton onClick={handleAddMaintenance}>
              <img src={plus} alt='Adicionar' style={{ marginRight: '8px' }} />
              Adicionar manutenção
            </AddMaintenanceButton>
          </Section>
        </ContentContainer>

        <ButtonContainer>
          <CancelButton type='button' onClick={onClose} disabled={isSaving}>
            Cancelar
          </CancelButton>
          <SaveButton type='button' onClick={handleSaveClick} disabled={isSaving}>
            <img src={save} alt='Salvar' style={{ marginRight: '8px' }} />
            {isSaving ? 'Salvando...' : 'Salvar alterações'}
          </SaveButton>
        </ButtonContainer>
      </Container>
    </BlurBackground>
  )
}

export default EditVehicleModal
